import {IUploadImage} from '../../../../models/utilities/uploadImage';
import styles from './uploader.module.scss';
import ProfileImage from '../../../../assets/image/shared/chat_empty_profile_image.svg';
import {useAuth} from '../../../../context/authContext';

type TUploaderProps = {
  setFile: React.Dispatch<React.SetStateAction<IUploadImage[]>>;
  images: Array<IUploadImage>;
};

const Uploader = ({setFile, images}: TUploaderProps) => {
  const {supplierProfile} = useAuth();
  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {files} = e?.target;
    if (files && files[0]) {
      setFile(prev => [
        {isSelected: prev?.length === 0 ? true : false, file: files?.[0]},
      ]);
    }
  };

  return (
    <>
      <div className={styles['uploader']}>
        <input type="file" onChange={handleUpload} accept=".jpg, .jpeg" />
        <div className={styles['uploader__img']}>
          <img
            src={
              images && images?.length > 0
                ? URL.createObjectURL(images[0]?.file)
                : supplierProfile?.profile_image || ProfileImage
            }
            alt=""
          />
          <i className="icon-edit-image-profile"></i>
        </div>
      </div>
    </>
  );
};

export default Uploader;
